// extracted by mini-css-extract-plugin
module.exports = {"OnePieceCardImage":"OnePieceCardImage_OnePieceCardImage__3QMuX","imageWrapper":"OnePieceCardImage_imageWrapper__P-obR"};